import React from 'react'
import { Link } from 'react-router-dom'
import { imageUrl } from '../../Constants/contant'

function Breadcrumb({ title, category }) {
    return (
        <>
           <div
            className="breadcumb-wrapper"
            style={{
                backgroundImage: `url(${category?.image ? imageUrl + category.image : '/assets/img/contact.jpg'})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "100%",
                minHeight: "300px" // height zaroori hai
            }}
            >

                
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{category?.title}</h1>
                        <ul className="breadcumb-menu">
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>{title}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Breadcrumb
